import React from "react"
import { User } from "firebase/auth"
import { LiveId, SelectionId, SelectionParticipantId, SelectionSequenceId, SpaceKey } from "popopo-msg"
import { Button } from "react-bootstrap"
import { useForm } from "react-hook-form"
import { api } from "../../core"

export const SelectionNominateAppealButton = (props: {
  firebase: User
  spaceKey: SpaceKey
  liveId: LiveId
  selectionId: SelectionId
  latestSequence: SelectionSequenceId | null,
  participantId: SelectionParticipantId,
}) => {
  const form = useForm({
    mode: "onBlur",
  })

  const { spaceKey, liveId, selectionId, participantId } = props

  const onClick = async (value: "camera" | "image") => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.PUT(`/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/nominates/{participant_id}/appeal`, {
        params: {
          path: {
            space_key: spaceKey,
            live_id: liveId,
            selection_id: selectionId,
            participant_id: participantId,
          },
        },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          kind: value,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <Button variant={"warning"} onClick={form.handleSubmit(() => onClick("camera"))}>
        Camera
      </Button>
      <Button variant={"warning"} onClick={form.handleSubmit(() => onClick("image"))}>
        Image
      </Button>
    </>
  )
}
